import { errorToast } from '$lib/components/common/toasts/Toast';
import type { ServerErrorResponse } from '$src/types/api.types';
import type { AxiosError } from 'axios';
import axios from 'axios';

export const handleAxiosError = (
  error: AxiosError<ServerErrorResponse>,
  showToast: boolean = false
) => {
  if (axios.isAxiosError(error)) {
    if (error.response) {
      if (error.response?.data?.message && showToast) errorToast(error.response?.data.message);

      throw error.response.data;
    } else if (error.request) {
      console.log('Request made but no response was received: ', error.request);
    } else {
      console.log('Error setting up the request: ', error.message);
    }
  } else {
    console.error('Unknown error occurred');
  }
};
